
/**
 * Cache utilities for debugging and clearing various browser caches
 */

// Clear browser storage related to usage validation
export const clearUsageValidationCache = () => {
  try {
    // Clear localStorage items related to AI Assistant
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.includes('ai-assistant') || 
        key.includes('usage') || 
        key.includes('supabase')
      )) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // Clear sessionStorage items related to AI Assistant
    const sessionKeysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && (
        key.includes('ai-assistant') || 
        key.includes('usage') || 
        key.includes('supabase')
      )) {
        sessionKeysToRemove.push(key);
      }
    }
    
    sessionKeysToRemove.forEach(key => sessionStorage.removeItem(key));
    
    console.log('[CACHE CLEAR] Cleared usage validation cache:', {
      localStorageKeys: keysToRemove,
      sessionStorageKeys: sessionKeysToRemove,
      timestamp: new Date().toISOString()
    });
    
    return true;
  } catch (error) {
    console.error('[CACHE CLEAR] Error clearing cache:', error);
    return false;
  }
};

// Force reload page with cache bypass
export const forceRefreshPage = () => {
  // Use location.reload with forceReload flag
  window.location.reload();
};

// Clear all browser caches and force refresh
export const clearAllCachesAndRefresh = () => {
  clearUsageValidationCache();
  
  // Clear any service worker caches if available
  if ('serviceWorker' in navigator && 'caches' in window) {
    caches.keys().then(cacheNames => {
      return Promise.all(
        cacheNames.map(cacheName => {
          console.log('[CACHE CLEAR] Deleting cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    }).then(() => {
      console.log('[CACHE CLEAR] All caches cleared, forcing refresh...');
      forceRefreshPage();
    }).catch(error => {
      console.error('[CACHE CLEAR] Error clearing service worker caches:', error);
      forceRefreshPage();
    });
  } else {
    forceRefreshPage();
  }
};
